import { FC } from 'react'
import cx from 'classnames'

type Props = {
  selectedColor: AvatarColor
  onSelect: (color: AvatarColor) => void
}

export const avatarColors = [
  'red',
  'orange',
  'amber',
  'emerald',
  'blue',
  'indigo',
  'violet',
] as const

export type AvatarColor = (typeof avatarColors)[number]

const colorClasses: Record<AvatarColor, string> = {
  red: 'bg-red-400 border-red-600',
  orange: 'bg-maroon-600 border-maroon-700',
  amber: 'bg-amber-400 border-amber-600',
  emerald: 'bg-emerald-400 border-emerald-600',
  blue: 'bg-blue-400 border-blue-600',
  indigo: 'bg-indigo-400 border-indigo-600',
  violet: 'bg-violet-400 border-violet-600',
}

const AvatarColorPicker: FC<Props> = ({ selectedColor, onSelect }) => {
  return (
    <div className="flex" data-testid="avatarColorPicker">
      {avatarColors.map((key) => {
        const isSelected = selectedColor === key
        return (
          <button
            key={key}
            type="button"
            onClick={() => onSelect(key)}
            data-testid={`avatar-${key}`}
            aria-pressed={isSelected}
            aria-label={key}
            className={cx(
              'mr-6 w-8 h-8 border-2 rounded-sm flex items-center justify-center focus:outline-none',
              colorClasses[key]
            )}
          >
            {isSelected && (
              <svg
                className="w-4 h-4 text-white"
                viewBox="0 0 14 14"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="2,7 6,11 12,3" />
              </svg>
            )}
          </button>
        )
      })}
    </div>
  )
}

export default AvatarColorPicker
